// ADO #480 — post-auth redirect ("next") persistence.
//
// The public site's "Try for Free" button sends users to
// /register?next=/start. That intent has to survive the whole auth round-trip:
//   • email signup -> /login -> email verify -> login
//   • Google OAuth redirect back to the app
// Router state does not survive those, so we stash it in localStorage.
//
// SECURITY: only same-origin internal paths are honored (must start with a
// single "/", never "//" or a scheme) to prevent open-redirect abuse.

const KEY = 'postAuthRedirect';

const isSafeInternalPath = (p) =>
  typeof p === 'string' && p.startsWith('/') && !p.startsWith('//') && !p.includes('://');

// Save a "next" target if it is a safe internal path.
export function saveNext(next) {
  if (isSafeInternalPath(next)) {
    localStorage.setItem(KEY, next);
  }
}

// Read the pending target without clearing it (null if none/unsafe).
export function peekNext() {
  const v = localStorage.getItem(KEY);
  return isSafeInternalPath(v) ? v : null;
}

// Read and clear the pending target, falling back to a default.
export function consumeNext(fallback = '/dashboard') {
  const v = peekNext();
  localStorage.removeItem(KEY);
  return v || fallback;
}
